import { Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { CompanyCandidateListQuery, Exact } from "@generated/graphql";
import { ApolloQueryResult } from "@apollo/client";
import useSetTabTitle from "hooks/useSetTabTitle";
import UploadTemplateModal from "./UploadTemplateModal";

interface HeaderProps {
  refetchList: (
    variables?: Partial<Exact<{ [key: string]: never }>>
  ) => Promise<ApolloQueryResult<CompanyCandidateListQuery>>;
}

const Header = ({ refetchList }: HeaderProps) => {
  const navigate = useNavigate();
  const [modalOpened, setModalOpened] = useState(false);
  const title = "Кандидаты";

  useSetTabTitle(title);

  return (
    <>
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent='space-between'
        sx={{ marginBottom: 2 }}>
        <Typography variant='h28'>{title}</Typography>
        <Stack
          spacing={2}
          direction='row'>
          <Button
            sx={{ backgroundColor: "#fff", color: "text.primary", "&:hover": { color: "#fff" } }}
            variant='contained'
            color='primary'
            onClick={() => setModalOpened(true)}>
            Загрузить кандидатов
          </Button>
          <Button
            variant='contained'
            onClick={() => {
              navigate("create");
            }}>
            Создать кандидата
          </Button>
        </Stack>
      </Stack>
      {modalOpened && (
        <UploadTemplateModal
          open={modalOpened}
          onSuccess={refetchList}
          handleClose={() => setModalOpened(false)}
        />
      )}
    </>
  );
};

export default Header;
